<template>
  <div class="container">
    <Breadcrumb :items="breadcrumbs" />
    <Booking :user="user" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Booking from "@/components/booking/Booking";
export default {
  components: {
    Breadcrumb,
    Booking
  },
  data() {
    return {
      // for components
      breadcrumbs: [
        { path: "/user", name: "Home" },
        { path: "/user/orders", name: "Orders" },
        { path: "", name: "Make a Booking" }
      ]
    };
  },
  created() {
    this.user = this.getUser();
  },
  methods: {
    ...mapGetters({
      getUser: "getUser"
    })
  }
};
</script>
